import React from 'react';
import { useTranslations } from 'next-intl';
import { cn } from '@wwe-portal/ui/lib/lib';
import { IcoMoonIcon } from '@wwe-portal/ui/components/icons';
import { tryFormatThousands } from '@wwe-portal/utils/format';

function RoasterTalent({
  rosterTalent,
  classes = '',
}: Readonly<{
  rosterTalent: string;
  classes?: string;
}>) {
  const t = useTranslations();

  return (
    <div className="player-account__box flex w-full items-center justify-center p-[10px] md:w-fit">
      <IcoMoonIcon
        iconName="medal-fill"
        className="text-deepSkyBlue size-[14px]"
      />
      <div
        className={cn(
          `text-text600 ml-[10px] flex items-center justify-center text-xs capitalize`,
          classes
        )}
      >
        {t('faction_total_talent')}:
        <p
          className={cn(
            `text-text500 mb-0 ml-[5px] flex items-center text-xs`,
            classes
          )}
        >
          {tryFormatThousands(rosterTalent)}
        </p>
      </div>
    </div>
  );
}

export default RoasterTalent;
